import { render } from "./LimitPaywallModal.vue?vue&type=template&id=2cc9f997&scoped=true"
import script from "./LimitPaywallModal.vue?vue&type=script&lang=js"
export * from "./LimitPaywallModal.vue?vue&type=script&lang=js"

import "./LimitPaywallModal.vue?vue&type=style&index=0&id=2cc9f997&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc9f997"]])

export default __exports__